import { iconsMap } from 'kidsout:icons'

import { wrapError } from '@app/utils/wrapError'

import { getIconsCache } from '@app/store/actions/contexts/iconCache'
import { createThunk } from '@app/store/thunk'

export const loadIcon = (size: string, name: string) => {
  return createThunk(async dispatch => {
    const iconCache = dispatch(getIconsCache())
    const existing = iconCache.get(size, name)
    if (existing) return existing
    try {
      const icon = (await iconsMap[size][name]()).default
      return iconCache.upsert(size, name, () => icon)
    } catch (e) {
      throw wrapError(new Error(`Cannot get icon: ${size}:${name}`), e)
    }
  })
}
